export function convertFormUrlParams(categoryParam: string) {
  return categoryParam.split("-").join("/");
}
